import React from 'react';
import { observer } from 'mobx-react';

import Container from './Container';
import MoreButton from './MoreButton';
import ListTitle from './ListTitle';
import TitleIcon from './TitleIcon';
import PageControls from './PageControls';
import ListMessage from './ListMessage';

export default observer(({ children, title, icon, controls, paginator }) => (
  <div>
    <Container>
      <ListTitle>
        {icon && <TitleIcon name={icon} />}
        {title}
        {controls === 'pages' && <PageControls paginator={paginator} />}
      </ListTitle>

      {controls === 'pages' ? paginator.isLoading ? <ListMessage>Loading ...</ListMessage> : children : children}

      {paginator.hasMorePages && (controls === 'more' || typeof controls === 'undefined') && (
        <MoreButton onClick={paginator.loadMore}>{paginator.isLoading ? 'Loading ...' : 'Load more'}</MoreButton>
      )}
    </Container>
  </div>
));
